import React, { useEffect, useState } from 'react'


import QRCode from 'react-qr-code'

import { filterObjFromList } from '../../../../Js/generalFunctions';
import { viewAllCurrencyUpdated } from '../../../../API/Settings/Currency/CurrencyAPI';
import { useSelector } from 'react-redux';




const JournalSinglePrint = ({tableData,formValues}) => {
    const [symbol, setSymbol] = useState(null);
    const [unit, setUnit] = useState(null);
console.log(tableData);
const decimalPosition=Number(localStorage.getItem("decimalPosition"))

    const currencyListUpdated = useSelector(
        (state) => state?.viewUpdatedCurrency?.value
      );
      const companyProfileData = useSelector(
        (state) => state?.companyProfileSlice?.userValue)
    
        
            useEffect(() => {
                let currencyObj = filterObjFromList(
                  "_id",
                  currencyListUpdated,
                  "currency",
                  companyProfileData
                );
                // console.log(currencyObj);
                setSymbol(currencyObj?.symbol);
                setUnit(currencyObj?.currencyUnit);
              }, [companyProfileData, currencyListUpdated]);
         useEffect(()=>{
            viewAllCurrencyUpdated({ status: 0 });
            // VendorPaymentSingleViewAPI({_id:singleViewId})
          },[])
  return (
   <div className="print-main-div">
    <div className="first-container">
        <div className="left-side-div">
            <img
                src={companyProfileData?.logo}
                alt=""
            />
            <h1 style={{ margin: "0", fontSize: "medium" }}>
               { companyProfileData?.companyName }
            </h1>
        </div>
        <div className="right-side-div" >
            <h1 style={{ fontWeight: "600", fontSize: "medium", color: "#3378ab" }}>Journal Entry</h1>
            <p style={{  color: "black", fontWeight: "400" }}>{formValues?.name}</p>
      
        </div>
    </div>
    <div className="secound-container">
        <div style={{ display: "flex", justifyContent: "space-between", width: "40%" }}>
            <div>
                <p>Journal*</p>
                <p>Accounting Date</p>
               
            </div>
            <div className='res-label'>
                <p>{formValues?.journal?.journalName}</p>
                <p>{formValues?.accountingDate}</p>
                
            </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", width: "40%" }}>
            <div>
                <p>Reference</p>
               
            </div>
            <div className='res-label'>
                <p>{formValues?.reference}</p>
                
            </div>
        </div>
    </div>
    <div className='table-div'>
        <table>
            <thead>
                <tr>
                    <th>Accounting</th>
                    <th>Partner</th>
                    <th>Employee</th>
                    <th>Branch</th>
                    <th>Reference</th>
                    <th>Debit</th>
                    <th>Credit</th>
                </tr>
            </thead>
            <tbody>
                {tableData?.map((item,index)=>(
                <tr key={index}>
                    <td>{item?.account?.accountName}</td>
                    <td>{item?.partner?.name}</td>
                    <td>{item?.employee}</td>
                    <td>{item?.branch?.storeCode}-{item?.branch?.branchName}</td>
                    <td >{item?.reference}</td>
                    <td >{item.debit}</td>
                    <td >{item.credit}</td>
                </tr>
                ))} 
                 <tr>
                  <td style={{ border: "0" }} colSpan={4} ></td>
                  <td style={{ border: "0", textAlign: "end",fontSize:"0.8rem",fontWeight:"600" }}>Total :</td>
                  <td style={{ border: "0", textAlign: "start" }}>{formValues?.debitTotal?.toFixed(decimalPosition)}</td>
                  <td style={{ border: "0", textAlign: "start" }}>{formValues?.creditTotal?.toFixed(decimalPosition)}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div className="global-print-total-field">
        <div>
            {/* <p style={{fontSize:"small"}}>Amount in Words: {singleView?.amountInWords}</p> */}
        </div>
        <div style={{ display: "flex", paddingTop:"35px"}}>
        <QRCode
      size={256}
      style={{
        height: "auto",
        width: "70px",
      }}
      value={"https://public/qrcode"}
      // value={"https://textile.eyeterp.com/userdashboard/sales/payments"}
      viewBox={`0 0 256 256`}
    />
        </div>
    </div>
    <div className='first-print-footer'>
        <p>Prepared By</p>
        <p>Signature</p>
    </div>
{/* <div className="print-footer" style={{backgroundColor:"#1b5d9f"}}>
<p>page 1/1</p>
</div> */}
</div>
  )
}

export default JournalSinglePrint